export default __webpack_public_path__ + "2640df423c50644026d330a3bccce98b.jpg";